import React from 'react'
import { fetcher } from 'app/hooks/fetcher'
import { Routes } from 'app/routes'
import { SWRConfig } from 'swr'
import ThemeProvider from 'theme/ThemeProvider'
import SocketProvider from './theme/SocketProvider'

const App = () => {
	return (
		<SWRConfig
			value={{
				fetcher: fetcher,
				dedupingInterval: 1000, // 1초 동안 동일한 요청 중복 방지
				revalidateOnFocus: false, // 포커스 시 재검증 비활성화
				revalidateOnReconnect: false, // 재연결 시 재검증 비활성화
				shouldRetryOnError: false, // 에러 시 재시도 비활성화
				errorRetryCount: 1, // 에러 재시도 횟수 제한
				errorRetryInterval: 3000, // 에러 재시도 간격
				provider: (): any => {
					const map = new Map(
						JSON.parse(localStorage.getItem('app-cache') || '[]')
					)
					window.addEventListener('beforeunload', () => {
						const appCache = JSON.stringify(
							Array.from(map.entries())
						)
						localStorage.setItem('app-cache', appCache)
					})
					return map
				},
			}}>
			<ThemeProvider>
				<SocketProvider>
					<Routes />
				</SocketProvider>
			</ThemeProvider>
		</SWRConfig>
	)
}

export default App
